import { EventEmitter } from "events";

const loaderEvent = new EventEmitter();

export default loaderEvent;